export const AUDIO_TOOL_EVENT_KEYS = {
  "audio-trimmer": "trimmer",
  "audio-converter": "converter",
  "video-audio-extractor": "video_audio_extractor",
  "audio-merger": "merger",
  "mp3-compressor": "compressor",
  "audio-speed-changer": "speed",
  "audio-cleaner": "audio_cleaner",
  "silence-remover": "silence_remover",
  "volume-normalizer": "volume_normalizer",
  "split-audio-by-silence": "split_by_silence",
  "audio-quality-checker": "quality_checker",
  "stereo-channel-splitter": "channel_splitter",
  "voice-recorder": "voice_rec",
  "tab-audio-recorder": "tab_rec",
  "tab-mic-recorder": "tab_mic",
  "meeting-recorder": "meeting_rec",
  "meeting-notes-generator": "meeting_notes",
  "word-counter": "word_counter",
  "reading-time-calculator": "reading_time",
  "audio-length-estimator": "length_estimator",
  "srt-vtt-cleaner": "subtitle_cleaner",
  "subtitle-time-shifter": "subtitle_shift",
  "transcript-quote-extractor": "quote_extractor",
  "srt-vtt-converter": "subtitle_converter",
  "subtitle-drift-fixer": "subtitle_drift",
  "subtitle-line-breaker": "subtitle_lines",
  "transcript-cleaner": "transcript_cleaner",
  "transcript-to-show-notes": "show_notes",
  "srt-vtt-to-plain-text": "subtitle_plain_text",
  "transcript-timestamp-finder": "timestamp_finder",
  "caption-fps-converter": "caption_fps",
};
